import { HttpClient, HttpStatusCode } from '@/data/protocols/http'
import { ForbiddenError, InvalidCredentialsError, SamePasswordError, UnexpectedError } from '@/domain/errors'
import { UpdatePassword, UpdatePasswordParams } from '@/domain/usecases'

export class RemoteUpdatePassword implements UpdatePassword {
  constructor (
    private readonly url: string,
    private readonly httpPostClient: HttpClient<boolean | string>
  ) {}

  async update (params: UpdatePasswordParams): Promise<void> {
    const { confirmacaoSenha, ...dataParams } = params

    if (dataParams.senhaAtual === dataParams.novaSenha) {
      throw new SamePasswordError()
    }

    const { statusCode, body } = await this.httpPostClient.request({
      method: 'post',
      url: `${this.url}/api/Clientes`,
      params: dataParams
    })

    switch (statusCode) {
      case HttpStatusCode.ok: break
      case HttpStatusCode.forbidden: throw new ForbiddenError(body as string)
      case HttpStatusCode.unauthorized: throw new InvalidCredentialsError()
      default: throw new UnexpectedError()
    }
  }
}
